import { ReactElementFactory } from "survey-react-ui";
import React from "react";
import { ItemValue, ListModel } from "survey-core";
import { CircleFlag } from "react-circle-flags";

const CurrencyItemComponent: React.FC<{
  item: ItemValue;
  key: number;
  model: ListModel;
}> = ({ item }) => {
  return (
    <div className="flex items-center gap-2">
      <CircleFlag
        countryCode={item.originalItem.flagName.toLowerCase()}
        width={20}
        height={20}
      />
      <span>{item.title}</span>
    </div>
  );
};

export default CurrencyItemComponent;

ReactElementFactory.Instance.registerElement("currency-item", (props) => {
  return React.createElement(CurrencyItemComponent, props);
});
